import { render, staticRenderFns } from "./toolbar-sports.vue?vue&type=template&id=5d423c65"
import script from "./toolbar-sports.vue?vue&type=script&lang=js"
export * from "./toolbar-sports.vue?vue&type=script&lang=js"
import style0 from "./toolbar-sports.vue?vue&type=style&index=0&id=5d423c65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports